import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { CallSummary } from '@/models/callLog';

export const getCallSummariesByCallLogId = async (callLogId: number): Promise<CallSummary[]> => {
  const response = await queryExecute({
    query: graphql(`
      query GetCallSummariesByCallLogId($callLogId: Float!) {
        getCallSummariesByCallLogId(callLogId: $callLogId) {
          id
          callLogId
          agentId
          summary
          createdAt
          updatedAt
          agent {
            id
            name
          }
          callLog {
            id
          }
        }
      }
    `),
    variables: {
      callLogId,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.getCallSummariesByCallLogId;
};
